import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { FadeSlideIn, ScalePopIn } from './Animations';
import { Button } from './Button';
import { cn } from './cn';

export interface ErrorStateProps {
  title: React.ReactNode;
  description: React.ReactNode;
  actionTitle?: string;
  onActionClick?: () => void;
  actionIcon?: React.ReactNode;
  className?: string;
}

export const ErrorState = ({
  title,
  description,
  actionTitle,
  onActionClick,
  actionIcon,
  className,
}: ErrorStateProps) => {
  return (
    <FadeSlideIn
      className={cn('flex flex-col items-center justify-center py-16 px-8 text-center', className)}
      offset={12}
      transition={{ duration: 0.4 }}
    >
      <ScalePopIn className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-status-danger-bg">
        <ExclamationTriangleIcon className="h-7 w-7 text-status-danger-icon" />
      </ScalePopIn>
      <h3 className="font-heading text-lg font-semibold text-text-primary leading-snug">{title}</h3>
      <p className="mt-1.5 text-sm text-text-muted max-w-md leading-relaxed">{description}</p>
      {actionTitle && onActionClick && (
        <FadeSlideIn delay={0.25}>
          <Button variant="outline" onClick={onActionClick} className="mt-5">
            {actionIcon}
            {actionTitle}
          </Button>
        </FadeSlideIn>
      )}
    </FadeSlideIn>
  );
};
